import React from "react";
import styles from "../DressingChangeFrequency.module.scss";

const SkeletonLine: React.FC<{ className: string }> = ({ className }) => (
  <span className={`${styles.skeleton} ${className}`} />
);

export const DressingChangeFrequencySkeleton: React.FC = () => (
  <div className={styles.skeleton_container} data-testid="dressing-change-frequency-skeleton" aria-busy="true">
    <div className={styles.skeleton_header}>
      <SkeletonLine className={styles.skeleton_title} />
      <SkeletonLine className={styles.skeleton_subtitle} />
      <SkeletonLine className={styles.skeleton_subtitle_short} />
    </div>
    {[0, 1].map((section) => (
      <section className={styles.skeleton_section} key={section}>
        <SkeletonLine className={styles.skeleton_section_title} />
        <div className={styles.skeleton_card}>
          <SkeletonLine className={styles.skeleton_card_title} />
          <SkeletonLine className={styles.skeleton_card_detail} />
          <SkeletonLine className={styles.skeleton_card_content} />
        </div>
      </section>
    ))}
  </div>
);
